import { Injectable }                    from '@angular/core';
import { Store }                         from '@ngrx/store';
import { renameDocument }                from '../../state/app.actions';
import { selectRenameDocumentIsLoading } from '../../state/app.selectors';

@Injectable({
  providedIn: 'root',
})
export class RenameDocumentService {
  renameDocumentIsLoading$ = this.store.select(selectRenameDocumentIsLoading);

  constructor(private readonly store: Store) {
  }

  renameDocument(name: string, documentId: string, clientId?: string, options?: {
    closeDialog?: boolean;
    reload?: boolean
  }) {
    this.store.dispatch(renameDocument({
      clientId,
      documentId,
      name,
      closeDialog: options?.closeDialog,
      reload: options?.reload,
    }));
  }
}
